$(document).ready(function () {
    // title inheritance is not implemented in icheck 1.* but this works
    // @see https://github.com/fronteed/icheck/issues/96
    $(document).on('ifCreated', 'input', function() {
        if (this.title) {
            $(this).parent().attr('title', this.title);
        }
    });

    parseCheckboxes();

});

$(document).on('loadFinish', function () {
    parseCheckboxes();
    // $(document).on('loadFinish', function () {
        $("select").on("chosen:showing_dropdown", function(evnt, params) {
            var chosen = params.chosen,
                $dropdown = $(chosen.dropdown),
                $field = $(chosen.form_field);
            if( !chosen.__customButtonsInitilized ) {
                chosen.__customButtonsInitilized = true;
                var contained = function( el ) {
                    var container = document.createElement("div");
                    container.appendChild(el);
                    return container;
                };
                var width = $dropdown.width();
                var opts = chosen.options || {},
                    showBtnsTresshold = opts.disable_select_all_none_buttons_tresshold || 0;
                var optionsCount = 0;
                var selectAllText = "";
                var selectNoneText = "";
                optionsCount = $field.children().length,
                    selectAllText = opts.select_all_text || '',
                    selectNoneText = opts.uncheck_all_text || '';
                if( chosen.is_multiple && optionsCount >= showBtnsTresshold ) {
                    var selectAllEl = document.createElement("a"),
                        selectAllElContainer = contained(selectAllEl),
                        selectNoneEl = document.createElement("a"),
                        selectNoneElContainer = contained(selectNoneEl);
                    selectAllEl.appendChild( document.createTextNode( selectAllText ) );
                    selectNoneEl.appendChild( document.createTextNode( selectNoneText ) );

                    $(selectAllEl).addClass("checkIcon");
                    $(selectNoneEl).addClass("banIcon");

                    $dropdown.prepend("<div class='ui-chosen-spcialbuttons-foot' style='clear:both;border-bottom: 1px solid black;'></div>");
                    $dropdown.prepend(selectNoneElContainer);
                    $dropdown.prepend(selectAllElContainer);
                    var $selectAllEl = $(selectAllEl).parent(),
                        $selectAllElContainer = $(selectAllElContainer),
                        $selectNoneEl = $(selectNoneEl).parent(),
                        $selectNoneElContainer = $(selectNoneElContainer);
                    var reservedSpacePerComp = (width - 25) / 2;
                    $selectNoneElContainer.addClass("ui-chosen-selectNoneBtnContainer")
                        .css("float", "right").css("padding-bottom", "19px")
                        .css("margin", "5px")
                        .css("max-width", reservedSpacePerComp+"px")
                        .css("max-height", "15px").addClass("btn").addClass("btn-xs");
                    $selectAllElContainer.addClass("ui-chosen-selectAllBtnContainer")
                        .css("float", "left").css("padding-bottom", "19px")
                        .css("margin", "5px")
                        .css("max-width", reservedSpacePerComp+"px")
                        .css("max-height", "15px").addClass("btn").addClass("btn-xs");
                    $selectAllEl.on("click", function(e) {
                        e.preventDefault();
                        $field.children().prop('selected', true);
                        $field.trigger('chosen:updated');
                        return false;
                    });
                    $selectNoneEl.on("click", function(e) {
                        e.preventDefault();
                        $field.children().prop('selected', false);
                        $field.trigger('chosen:updated');
                        return false;
                    });
                }
            }
        });
    // });
});

var parseCheckboxes = function () {
    $('input:not(.toggle):not(.no-ready)').iCheck({
        checkboxClass: 'checkbox-square',
        radioClass: 'radio-square',
        increaseArea: '20%' // optional
    });
    var checkboxToggle = $('input.toggle');
    $.each(checkboxToggle, function () {
        if ($(this).prop("style")['opacity'] === "") {
            $(this).iCheck({
                        checkboxClass: 'checkbox-toggle',
                        radioClass: 'radio-toggle',
                        increaseArea: '20%' // optional
                    });
        }
    });

};

window.parseCheckboxes = parseCheckboxes;